import _ from 'lodash';
import axios, { AxiosInstance } from 'axios';
import { setupCache } from 'axios-cache-interceptor';

// 初始化axios实例
const axiosInstance: AxiosInstance = setupCache(axios.create());

axiosInstance.defaults.withCredentials = true;

// 请求拦截器
axiosInstance.interceptors.request.use((config) => {
  return config;
}, (error) => Promise.reject(error));

// 响应拦截器
axiosInstance.interceptors.response.use((response) => {
  const {
    code,
    msg,
  } = _.get(response, 'data', {}) as any;

  if (code && code !== 200) {
    const error = new Error(msg);
    return Promise.reject(error);
  }

  return response.data;
}, (error) => Promise.reject(error));

export default axiosInstance;
